import { dbsKeys } from "data/dbsKeys";
import { adminSeedCollections } from "data/admin/seedData";

const storageKeysByCollection = {
  provinces: dbsKeys.provinces,
  deals: dbsKeys.deals,
  businesses: dbsKeys.businesses,
  bookings: dbsKeys.bookings,
  subscriptions: dbsKeys.subscriptions,
  users: dbsKeys.users,
};

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function safeParse(raw, fallback) {
  if (!raw) return fallback;

  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function ensureCollectionSeed(collectionName) {
  if (typeof window === "undefined") return;

  const storageKey = storageKeysByCollection[collectionName];
  if (!storageKey) return;

  if (!window.localStorage.getItem(storageKey)) {
    window.localStorage.setItem(storageKey, JSON.stringify(adminSeedCollections[collectionName] || []));
  }
}

export function createBrowserAdminAdapter() {
  return {
    kind: "browser-storage",
    label: "Browser storage adapter",

    listCollection(collectionName) {
      ensureCollectionSeed(collectionName);

      const storageKey = storageKeysByCollection[collectionName];
      if (!storageKey || typeof window === "undefined") {
        return clone(adminSeedCollections[collectionName] || []);
      }

      return clone(safeParse(window.localStorage.getItem(storageKey), adminSeedCollections[collectionName] || []));
    },

    writeCollection(collectionName, items) {
      const storageKey = storageKeysByCollection[collectionName];
      if (!storageKey || typeof window === "undefined") return;
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    },
  };
}